__turbopack_context__.v({
  "container": "PulseLoader-module__AdoX2W__container",
  "pulse": "PulseLoader-module__AdoX2W__pulse",
  "pulseanim": "PulseLoader-module__AdoX2W__pulseanim",
});
